import { get } from "@insite/client-framework/Services/ApiService";

export interface OrderAttributeResultModel {
    attribute?: string;
    attributeValue?: string;
}

export const getOrderAttributeFn = async (orderNumber: string) => {
    const response = await get<OrderAttributeResultModel[]>(
        `/api/v2/orderhistory/GetCustomerReferenceFields?orderNumber=${orderNumber}`,
    );
    return response;
};
